import { useWaveSurferRecorderContext } from "../stores/wavesurfer-recorder";

type TProps = {
  className?: string;
};
const WaveSurferRecorder = (props: TProps) => {
  const { containerRef, height } = useWaveSurferRecorderContext();

  return (
    <>
      <div
        ref={containerRef}
        className={`min-h-[${height}px] border rounded-md ${props.className}`}
      />
    </>
  );
};

export default WaveSurferRecorder;
